/**
 * Groovy Collection Filter v2 — Google Shopping style
 * Persistent sidebar on desktop, slide-in panel on mobile.
 * Reuses the same data-filters attribute format as v1.
 */
(function() {
  'use strict';

  function boot() {
    var $ = window.jQuery;
    if (!$) { setTimeout(boot, 50); return; }

  var GCF2 = {
    groups: [],
    state: {},
    priceBounds: { min: 0, max: 0 },

    init: function() {
      var $sidebar = $('#gcf2-sidebar');
      if (!$sidebar.length) return;

      this.groups = [];
      this.state = {};

      var self = this;

      // Discover groups from the DOM
      $sidebar.find('.gcf2-group[data-group]').each(function() {
        var name = $(this).data('group');
        if (name !== 'price') {
          self.groups.push(name);
          self.state[name] = [];
        }
      });

      // Price bounds
      var $minInput = $('#gcf2-price-min');
      if ($minInput.length) {
        this.priceBounds.min = parseInt($minInput.data('price-bound-min'), 10);
        this.priceBounds.max = parseInt($minInput.data('price-bound-max'), 10);
        this.state.priceMin = this.priceBounds.min;
        this.state.priceMax = this.priceBounds.max;
      } else {
        this.state.priceMin = 0;
        this.state.priceMax = Infinity;
      }

      this.bindEvents();
      this.updateResultsCount();
    },

    bindEvents: function() {
      var self = this;
      $(document).off('.gcf2');

      // Group toggle (collapse/expand)
      $(document).on('click.gcf2', '.gcf2-group-toggle', function(e) {
        e.preventDefault();
        var expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
      });

      // Checkbox change
      $(document).on('change.gcf2', '[data-filter-group]', function() {
        var group = $(this).data('filter-group');
        self.state[group] = [];
        $('[data-filter-group="' + group + '"]:checked').each(function() {
          self.state[group].push($(this).val());
        });
        self.applyFilters();
      });

      // Price input change (debounced)
      var priceTimer;
      $(document).on('input.gcf2', '.gcf2-price-input', function() {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(function() {
          self.handlePriceInput();
        }, 400);
      });

      // Clear all
      $(document).on('click.gcf2', '#gcf2-clear-btn', function() {
        self.clearAll();
      });

      // Remove active filter pill
      $(document).on('click.gcf2', '.gcf2-pill', function() {
        var group = $(this).data('pill-group');
        var val = $(this).data('pill-value');
        $('[data-filter-group="' + group + '"][value="' + val + '"]').prop('checked', false).trigger('change');
      });

      // Mobile: open sidebar
      $(document).on('click.gcf2', '#gcf2-mobile-trigger', function() {
        self.openMobile();
      });

      // Mobile: close via overlay
      $(document).on('click.gcf2', '#gcf2-overlay', function() {
        self.closeMobile();
      });

      // Escape key
      $(document).on('keydown.gcf2', function(e) {
        if (e.key === 'Escape') {
          self.closeMobile();
        }
      });
    },

    openMobile: function() {
      $('#gcf2-sidebar').addClass('gcf2-sidebar--open');
      $('#gcf2-overlay').addClass('gcf2-overlay--visible');
      $('body').css('overflow', 'hidden');
    },

    closeMobile: function() {
      $('#gcf2-sidebar').removeClass('gcf2-sidebar--open');
      $('#gcf2-overlay').removeClass('gcf2-overlay--visible');
      $('body').css('overflow', '');
    },

    handlePriceInput: function() {
      var minVal = parseInt($('#gcf2-price-min').val(), 10) || 0;
      var maxVal = parseInt($('#gcf2-price-max').val(), 10) || Infinity;
      this.state.priceMin = minVal * 100; // Convert dollars to cents
      this.state.priceMax = maxVal * 100;
      this.applyFilters();
    },

    parseFilters: function(filterStr) {
      var result = {};
      if (!filterStr) return result;
      filterStr.split('|').forEach(function(pair) {
        var eqIndex = pair.indexOf('=');
        if (eqIndex > 0) {
          var key = pair.substring(0, eqIndex);
          var val = pair.substring(eqIndex + 1);
          if (!result[key]) result[key] = [];
          result[key].push(val);
        }
      });
      return result;
    },

    applyFilters: function() {
      var self = this;
      var visibleCount = 0;
      var totalCount = 0;

      $('.gcf-product-card').each(function() {
        totalCount++;
        var $card = $(this);
        var productFilters = self.parseFilters($card.attr('data-filters'));
        var price = parseInt($card.attr('data-price'), 10) || 0;

        var matchAll = true;
        for (var i = 0; i < self.groups.length; i++) {
          var group = self.groups[i];
          if (self.state[group] && self.state[group].length > 0) {
            var productValues = productFilters[group] || [];
            var matchGroup = self.state[group].some(function(v) {
              return productValues.indexOf(v) !== -1;
            });
            if (!matchGroup) {
              matchAll = false;
              break;
            }
          }
        }

        var matchPrice = price >= self.state.priceMin && price <= self.state.priceMax;

        if (matchAll && matchPrice) {
          $card.removeClass('gcf2-hidden');
          visibleCount++;
        } else {
          $card.addClass('gcf2-hidden');
        }
      });

      this.updateActivePills();
      this.updateResultsCount(visibleCount, totalCount);
      this.toggleNoResults(visibleCount === 0 && totalCount > 0);
      this.toggleClearButton();
      this.updateMobileBadge();
    },

    updateActivePills: function() {
      var self = this;
      var $container = $('#gcf2-active-filters');
      $container.empty();

      this.groups.forEach(function(group) {
        if (self.state[group] && self.state[group].length > 0) {
          self.state[group].forEach(function(val) {
            var $pill = $('<span class="gcf2-pill"></span>')
              .attr('data-pill-group', group)
              .attr('data-pill-value', val)
              .html(val + ' <span class="gcf2-pill-x">&times;</span>');
            $container.append($pill);
          });
        }
      });
    },

    updateResultsCount: function(visible, total) {
      if (typeof visible === 'undefined') {
        total = $('.gcf-product-card').length;
        visible = total;
      }

      var text;
      if (this.hasActiveFilters()) {
        text = visible + ' of ' + total + ' results';
      } else {
        text = total + ' results';
      }

      $('#gcf2-results-count').text(text);
      $('#gcf2-mobile-results').text(text);
    },

    toggleNoResults: function(show) {
      $('#gcf2-no-results').toggleClass('gcf2-no-results--visible', show);
      $('#gcf-product-grid').toggle(!show);
    },

    toggleClearButton: function() {
      var active = this.hasActiveFilters();
      $('#gcf2-clear-btn').toggleClass('gcf2-clear-btn--visible', active);
    },

    updateMobileBadge: function() {
      var count = 0;
      var self = this;
      this.groups.forEach(function(group) {
        count += (self.state[group] || []).length;
      });
      var $badge = $('#gcf2-mobile-badge');
      if (count > 0) {
        $badge.text(count).addClass('gcf2-mobile-badge--visible');
      } else {
        $badge.removeClass('gcf2-mobile-badge--visible');
      }
    },

    hasActiveFilters: function() {
      var self = this;
      var hasGroup = this.groups.some(function(group) {
        return self.state[group] && self.state[group].length > 0;
      });
      var hasPrice = this.state.priceMin > this.priceBounds.min ||
                     this.state.priceMax < this.priceBounds.max;
      return hasGroup || hasPrice;
    },

    clearAll: function() {
      var self = this;
      this.groups.forEach(function(group) {
        self.state[group] = [];
      });
      this.state.priceMin = this.priceBounds.min;
      this.state.priceMax = this.priceBounds.max;

      $('[data-filter-group]').prop('checked', false);
      $('#gcf2-price-min').val(Math.floor(this.priceBounds.min / 100));
      $('#gcf2-price-max').val(Math.ceil(this.priceBounds.max / 100));

      this.applyFilters();
    }
  };

  // Initialize
  $(function() {
    GCF2.init();
  });

  if (window.InstantClick) {
    InstantClick.on('change', function() {
      GCF2.init();
    });
  }

  } // end boot()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
